<mat-card style="overflow-x: hidden !important;">
   <form #loginForm="ngForm" enctype="multipart/form-data">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <h2 style="padding-left:2px">{{ 'ticketingDialog.titol' | translate }}</h2>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right:0" (click)="desar()" matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-card-content style="float:left;clear:both;padding: 24px 5px">
      <mat-form-field style="width:25%">
        <mat-select style="width:100%" [(ngModel)]="editTicketingData.id_tipus" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.tipus' | translate }}">
          <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus.value">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:30%">
        <mat-select style="width:100%" [(ngModel)]="editTicketingData.sub_tipus" [ngModelOptions]="{standalone: true}" placeholder="{{ 'ticketingDialog.subTipus' | translate }}">
          <mat-option *ngFor="let subtipus of subTipusFiltrats" [value]="subtipus.text">{{subtipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:35%">
          <input matInput placeholder="{{ 'ticketingDialog.deLabel' | translate }}" name="De:" 
        [(ngModel)]="data.nom" ngDefaultControl disabled
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput placeholder="{{ 'ticketingDialog.dataPeticio' | translate }}" name="data" type="date"
         [(ngModel)]="editTicketingData.data_peticio" ngDefaultControl 
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput placeholder="{{ 'ticketingDialog.horaPeticio' | translate }}" name="hora" type="time"
        [(ngModel)]="editTicketingData.hora" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:95%">
          <input matInput placeholder="{{ 'seguimentTecnic.colAssumpte' | translate }}" name="assumpte" 
        [(ngModel)]="editTicketingData.assumpte" ngDefaultControl
       />
      </mat-form-field>
      <mat-card-content>
         <label style="display:block; margin-bottom: 1rem">{{ 'ticketingDialog.nivellUrgencia' | translate }}</label>
         <mat-slider
          color="primary"
          [(value)]="editTicketingData.urgencia"
          min="0" max="2" step="1" discrete>
         </mat-slider>
         <div class="tick-labels">
            <span>{{ 'ticketingDialog.pocUrgent' | translate }}</span>
            <span>{{ 'ticketingDialog.moderat' | translate }}</span>
            <span>{{ 'ticketingDialog.moltUrgent' | translate }}</span>
         </div>
      </mat-card-content>
      <mat-form-field style="width:130px">
        <input matInput
          placeholder="{{ 'ticketingDialog.dataAcceptacio' | translate }}"
          name="data_acord"
          type="date"
          [(ngModel)]="editTicketingData.data_acord"
          [disabled]="!userInfo.admin"
          ngDefaultControl
        />
      </mat-form-field>
      <mat-form-field style="width:130px">
        <input matInput
          placeholder="{{ 'ticketingDialog.dataDenegacio' | translate }}"
          name="data_denegacio"
          type="date"
          [(ngModel)]="editTicketingData.data_denegacio"
          [disabled]="!userInfo.admin"
          ngDefaultControl
        />
      </mat-form-field> 
      <mat-form-field style="width: 95%">
        <textarea matInput
          placeholder="{{ 'ticketingDialog.acords' | translate }}"
          name="acords"
          rows="2"
          [(ngModel)]="editTicketingData.acords"
          [disabled]="!userInfo.admin">
        </textarea>
      </mat-form-field> 
      <mat-form-field style="width:130px">
        <input matInput
          placeholder="{{ 'ticketingDialog.dataRealitzacio' | translate }}"
          name="data_realitzacio"
          type="date"
          [(ngModel)]="editTicketingData.data_realitzacio"
          [disabled]="!userInfo.admin"
          ngDefaultControl
        />
      </mat-form-field>
      <mat-card-content>
        <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:30px">
          <div class="lbl_dlg" style="padding-top:7px;float:left;clear:left;width:200px">{{ 'ticketingDialog.documentacioAssociada' | translate }}</div>
          <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="editTicketingData.filename"><a href="#" (click)="desarFitxer($event, editTicketingData.filename  ,'documents/ticketing')" attr.alt="{{ 'ticketingDialog.veureArxiu' | translate }}">{{editTicketingData.filename}}</a>
          </div>
          <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="editTicketingData.filename">
            <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="editTicketingData.filename = ''" color="primary">delete_forever</mat-icon>
          </div>
        </div>
        <div style="float:left;clear:left;width:100%">
          <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
            <div style="float:left;clear:none;padding-top:5px">{{ 'ticketingDialog.carregarDocument' | translate }}</div>
            <div style="float:left;clear:none">
              <label for="file">
                <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="{{ 'ticketingDialog.extensioMinuscules' | translate }}" attr.aria-label="{{ 'ticketingDialog.extensioMinuscules' | translate }}" matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
            </div>
          </div>
          <div style="float:left;clear:left;position: absolute;width:100%">
            <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="file" name="file" (change)="onFileChange($event)"/> {{ 'ticketingDialog.maxMida' | translate }}
          </div>
        </div>
        <div style="float:left;clear:left;width:100%" *ngIf="editTicketingData.id === 'NEW'">
           {{ 'ticketingDialog.desarPrimer' | translate }}
        </div>
      </mat-card-content> 
    </mat-card-content>
  </form>
</mat-card>
